import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import NotFound from '../../pages/NotFound';
import PublicLayout from '../../components/PublicLayout';

const InscricoesAdmin = lazy(() =>
  import('../../pages/Inscricoes/PremiereAdmin'),
);
const InscricoesPremiereBrasilSucesso = lazy(() =>
  import('../../pages/Inscricoes/PremiereBrasilSucesso'),
);
const MovieImagePage = lazy(() => import('../../components/MovieImagePage'));
const CredenciamentoPremiereInscricao = lazy(() =>
  import('../../pages/Credenciamento/Premiere/Inscricao'),
);
const CredenciamentoPremiereInscricaoSucesso = lazy(() =>
  import('../../pages/Credenciamento/Premiere/Sucesso'),
);
const CredenciamentoImprensaInscricao = lazy(() =>
  import('../../pages/Credenciamento/Imprensa/Inscricao'),
);
const CredenciamentoImprensaInscricaoSucesso = lazy(() =>
  import('../../pages/Credenciamento/Imprensa/Sucesso'),
);
const CredenciamentoImprensaIngressos = lazy(() =>
  import('../../pages/Credenciamento/Imprensa/Ingressos'),
);

/*
 * Rotas dos dominios publicos (ver src/common/areas.js). Nenhum deles tem
 * login nem tela da area logada: o que nao estiver aqui cai no NotFound.
 */
function PublicRoutes({ area }) {
  return (
    <PublicLayout minimal={area === 'filmes'}>
      <Routes>
        {area === 'credenciamento' && (
          <>
            <Route
              path="/imprensa/inscricao"
              exact
              element={<CredenciamentoImprensaInscricao />}
            />
            <Route
              path="/imprensa/sucesso"
              exact
              element={<CredenciamentoImprensaInscricaoSucesso />}
            />
            <Route
              path="/imprensa/ingressos"
              exact
              element={<CredenciamentoImprensaIngressos />}
            />
            <Route
              path="/filme/:seq/:token"
              exact
              element={<CredenciamentoPremiereInscricao />}
            />
            <Route
              path="/filme/:seq/sucesso"
              exact
              element={<CredenciamentoPremiereInscricaoSucesso />}
            />
          </>
        )}
        {area === 'filmes' && (
          <Route path="/:id" exact element={<MovieImagePage />} />
        )}
        {/* Sem nada em "/": cada formulario tem o seu endereco. */}
        {area === 'premierebrasil' && (
          <>
            <Route
              path="/inscricoes/mostras-competitivas"
              exact
              element={<InscricoesAdmin competition />}
            />
            <Route
              path="/inscricoes/mostras-competitivas/sucesso"
              exact
              element={
                <InscricoesPremiereBrasilSucesso featureKey="inscricoes_festival" />
              }
            />
            <Route
              path="/inscricoes/mostras-nao-competitivas"
              exact
              element={<InscricoesAdmin competition={false} />}
            />
            <Route
              path="/inscricoes/mostras-nao-competitivas/sucesso"
              exact
              element={
                <InscricoesPremiereBrasilSucesso featureKey="inscricoes_nao_competitivas" />
              }
            />
          </>
        )}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </PublicLayout>
  );
}

export default PublicRoutes;
